export default function() {

  $('.form-control').on('focus', function() {
    $(this).closest('.input-group').find('.input-group-prepend .input-group-text').addClass('active');
  }).on('blur', function() {
    $(this).closest('.input-group').find('.input-group-prepend .input-group-text').removeClass('active');
  });

}